var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var getErrorMessage = function (error) {
    if (error instanceof Error) {
        return error.message;
    }
    return String(error);
};
export { getErrorMessage };
var GrpcError = /** @class */ (function (_super) {
    __extends(GrpcError, _super);
    function GrpcError(code) {
        var _this = _super.call(this, "GRPC error: ".concat(code)) || this;
        _this.name = 'GrpcError';
        _this.code = code;
        return _this;
    }
    return GrpcError;
}(Error));
export { GrpcError };
//# sourceMappingURL=error.js.map